import { render, staticRenderFns } from "./BibleDialog.vue?vue&type=template&id=40e2982b&scoped=true&"
import script from "./BibleDialog.vue?vue&type=script&lang=js&"
export * from "./BibleDialog.vue?vue&type=script&lang=js&"
import style0 from "./BibleDialog.vue?vue&type=style&index=0&id=40e2982b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e2982b",
  null
  
)

export default component.exports